// extracted by mini-css-extract-plugin
export default {"container":"Roles_container__80S8u","text":"Roles_text__DrB7S","title":"Roles_title__CRtBu","createButton":"Roles_createButton__7Leyu"};